export const getAmountToReceive = (
  symbolName: string,
  assetCodeToPay: string,
  assetCodeToReceive: string,
  priceBid: number,
  priceAsk: number,
  amountToPay: string
) => {
  if (symbolName === `${assetCodeToPay}${assetCodeToReceive}`) {
    return Number(amountToPay) * priceBid;
  } else if (symbolName === `${assetCodeToReceive}${assetCodeToPay}`) {
    return Number(amountToPay) / priceAsk;
  }

  throw new Error('Invalid symbol name');
};

export const getAmountToPay = (
  symbolName: string,
  assetCodeToPay: string,
  assetCodeToReceive: string,
  priceBid: number,
  priceAsk: number,
  amountToReceive: string
) => {
  if (symbolName === `${assetCodeToPay}${assetCodeToReceive}`) {
    return Number(amountToReceive) / priceBid;
  } else if (symbolName === `${assetCodeToReceive}${assetCodeToPay}`) {
    return Number(amountToReceive) * priceAsk;
  }

  throw new Error('Invalid symbol name');
};
